import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import HomeBuilder from "@/components/admin/cms/HomeBuilder";
import PageIntroEditor from "@/components/admin/cms/PageIntroEditor";
import WatchImageManager from "@/components/admin/cms/WatchImageManager";
import NavFooterEditor from "@/components/admin/cms/NavFooterEditor";
import { PAGE_INTROS } from "@/lib/cms";
import { LayoutTemplate, ExternalLink } from "lucide-react";

export default function AdminSitePages() {
  return (
    <div data-testid="admin-cms" className="max-w-4xl">
      <div className="flex items-center justify-between mb-5 gap-3 flex-wrap">
        <div className="flex items-center gap-2">
          <LayoutTemplate className="text-[#c9a86a]" size={22} />
          <div>
            <h1 className="text-2xl font-semibold">Site Pages</h1>
            <p className="text-sm text-[var(--text-2)]">Edit homepage sections and page intros. The homepage supports draft &amp; preview before publishing.</p>
          </div>
        </div>
        <a href="/" target="_blank" rel="noreferrer" className="text-sm text-[#9a7b3f] hover:opacity-80 transition-opacity flex items-center gap-1" data-testid="cms-view-live">
          View live <ExternalLink size={13} />
        </a>
      </div>

      <Tabs defaultValue="home" className="w-full">
        <TabsList className="mb-6 flex flex-wrap h-auto gap-1 bg-[var(--panel-2)] p-1">
          <TabsTrigger value="home" data-testid="cms-tab-home">Homepage</TabsTrigger>
          <TabsTrigger value="vip" data-testid="cms-tab-vip">VIP</TabsTrigger>
          <TabsTrigger value="bespoke" data-testid="cms-tab-bespoke">Bespoke</TabsTrigger>
          <TabsTrigger value="sell" data-testid="cms-tab-sell">Sell</TabsTrigger>
          <TabsTrigger value="journal" data-testid="cms-tab-journal">Journal</TabsTrigger>
          <TabsTrigger value="nav" data-testid="cms-tab-nav">Menu & Footer</TabsTrigger>
          <TabsTrigger value="watches" data-testid="cms-tab-watches">Watch Images</TabsTrigger>
        </TabsList>

        <TabsContent value="home"><HomeBuilder /></TabsContent>
        <TabsContent value="vip"><PageIntroEditor intro={PAGE_INTROS.vip} /></TabsContent>
        <TabsContent value="bespoke"><PageIntroEditor intro={PAGE_INTROS.bespoke} /></TabsContent>
        <TabsContent value="sell"><PageIntroEditor intro={PAGE_INTROS.sell} /></TabsContent>
        <TabsContent value="journal"><PageIntroEditor intro={PAGE_INTROS.journal} /></TabsContent>
        <TabsContent value="nav"><NavFooterEditor /></TabsContent>
        <TabsContent value="watches"><WatchImageManager /></TabsContent>
      </Tabs>
    </div>
  );
}
